import picture from "../../assets/elsje.png";
import "./elsje.scss";

const Elsje = () => (
  <div className="elsje">
    <img src={picture} alt="Elsje Verfaillie" />
    <span className="name">Elsje Verfaillie</span>
    <a className="tel" href="tel:+41791948392">+41 (0)79 194 83 92</a>
    <a className="mail" href="mailto:elsje@evres.ch">elsje@evres.ch</a>
  </div>);

export default Elsje;
